class PivotInvoiceForm extends HTMLElement {
  constructor() {
    super();

    this._state = {
      button: 'save',
      disabledButton: true,
      disabledMainButton: false,
    };
    this._touchedRut = false;
    this._initialValues = null;
    this._hasSavedData = false;


    const mappingNode = this.querySelector('#pivot-invoice-regions-mapping');
    this.$regionsMapping = mappingNode ? JSON.parse(mappingNode.textContent) : {};
    this.$mainButton = null;

    this.$rutInput = this.querySelector('input[name="attributes[RUTEmpresa]"]');
    this.$regionSelector = this.querySelector('select[name="attributes[Region]"]');
    this.$communeSelector = this.querySelector('select[name="attributes[Comuna]"]');
    this.$form = this.querySelector('form.details-content');
    this.$label = this.querySelector('.cart-discount__label');
    this.$button = this.querySelector('button[type="submit"]');
    this.$clearButton = this.querySelector('#pivot-invoice-clear');
    this.$rutErrorMessage = this.querySelector('.rut-error-message');

    if (!this.$form || !this.$rutInput || !this.$regionSelector || !this.$communeSelector) {
      console.warn('PivotInvoiceForm: faltan elementos requeridos en el DOM');
      return;
    }

    this.initEvents();

    this._initialValues = this.getFormValues();
    this._hasSavedData = this.areAllFilled();

    // Verificacion inicial del estado del formulario
    this.checkFormState(false);
  }

  resolveCheckoutButton = () => {
    const isMainCart = this.classList.contains('location-main-cart');

    if (isMainCart) {
      const mainCartRoot = this.closest('#main-cart-items') || document.querySelector('#main-cart-items');
      const mainCartButton = mainCartRoot?.querySelector('button[type="submit"][name="checkout"][form="cart"]');
      if (mainCartButton) return mainCartButton;

      const checkoutAreaButton = document.querySelector('.form-checkout button[type="submit"][name="checkout"][form="cart"]');
      if (checkoutAreaButton) return checkoutAreaButton;
    } else {
      const drawerRoot = this.closest('#CartDrawer') || document.querySelector('#CartDrawer');
      const drawerButton = drawerRoot?.querySelector('button[type="submit"][name="checkout"][form="CartDrawer-Form"]');
      if (drawerButton) return drawerButton;
    }

    return document.querySelector('button#checkout-submit[type="submit"][name="checkout"]');
  };

  onStateChange = () => {
    this.$button = this.querySelector('button[type="submit"]');
    this.$clearButton = this.querySelector('#pivot-invoice-clear');
    this.$mainButton = this.resolveCheckoutButton();

    if (this.$button) {
      this.$button.disabled = this._state.disabledButton;
    }
    if (this.$clearButton) {
      this.$clearButton.disabled = this._state.disabledButton;
    }
    if (this.$mainButton) {
      this.$mainButton.disabled = this._state.disabledMainButton;

      const isCheckoutDisabled = this.$mainButton.disabled;
      this.$mainButton.style.opacity = isCheckoutDisabled ? '0.6' : '';
      this.$mainButton.style.cursor = isCheckoutDisabled ? 'not-allowed' : '';
      this.$mainButton.style.pointerEvents = isCheckoutDisabled ? 'none' : '';
    }

    if (this._state.button === 'save') {
      if (this.$button) {
        this.$button.style.display = 'block';
      }
      if (this.$clearButton) {
        this.$clearButton.style.display = 'none';
      }
    } else {
      if (this.$button) {
        this.$button.style.display = 'none';
      }
      if (this.$clearButton) {
        this.$clearButton.style.display = 'block';
      }
    }
  };

  initEvents = () => {
    this.$regionSelector.addEventListener('change', this.handleRegionChange);
    this.$rutInput.addEventListener('keyup', this.handleRutChange);
    this.$rutInput.addEventListener('blur', this.handleRutChange);
    this.$form.addEventListener('submit', this.handleSubmit);
    this.$clearButton.addEventListener('click', this.handleClear);

    this.handleRegionChange();
    this.$communeSelector.value = this.$communeSelector.dataset.value;
    this.$rutErrorMessage.classList.remove('show');
    this.$rutErrorMessage.hidden = true;

    this.$form.addEventListener('change', () => {
      this.checkFormState();
    });
    this.$form.addEventListener('input', () => {
      this.checkFormState();
    });
  };

  checkFormState = () => {
    this.syncRutValidity();

    const $invalid = this.$form.querySelector(':invalid');
    const $inputs = this.$form.querySelectorAll('input, select');
    const allEmpty = Array.from($inputs).every((input) => input.value === '');
    const allFilled = Array.from($inputs).every((input) => input.value !== '');
    const isDirty = this.isDirty();

    if (allEmpty) {
      this.$clearButton.classList.remove('button-secondary');
    } else {
      this.$clearButton.classList.add('button-secondary');
    }

    if (!isDirty && this._hasSavedData && allFilled && !$invalid) {
      this._state.button = 'clear';
      this._state.disabledButton = false;
    } else {
      this._state.button = 'save';
      this._state.disabledButton = !allFilled || !!$invalid;
    }

    this._state.disabledMainButton = isDirty;
    this.onStateChange();
  };

  handleRegionChange = () => {
    const region = this.$regionSelector.value;
    const communes = this.$regionsMapping[region];
    if (!communes) return;
    this.$communeSelector.innerHTML =
      '<option value="">Selecciona una comuna</option>' +
      communes.map((commune) => `<option value="${commune}">${commune}</option>`).join('');
  };

  handleRutChange = () => {
    this._touchedRut = true;
    this.syncRutValidity();
    this.checkFormState();
  };

  syncRutValidity = () => {
    const value = this.$rutInput.value;
    if (value === '') {
      this.$rutInput.setCustomValidity('');
      this.$rutErrorMessage.classList.remove('show');
      this.$rutErrorMessage.hidden = true;
      return;
    }

    if (validateRut(value)) {
      this.$rutInput.setCustomValidity('');
      this.$rutInput.value = formatDNI({ rut: value, pais: 'CL' });
      this.$rutErrorMessage.classList.remove('show');
      this.$rutErrorMessage.hidden = true;
      return;
    }

    this.$rutInput.setCustomValidity('Ingresa un RUT valido');
    const shouldShow = this._touchedRut === true;
    this.$rutErrorMessage.classList.toggle('show', shouldShow);
    this.$rutErrorMessage.hidden = !shouldShow;
  };

  getFormValues = () => {
    const values = {};
    this.$form.querySelectorAll('input, select').forEach((input) => {
      values[input.name] = input.value;
    });
    return values;
  };

  areAllFilled = () => {
    return Array.from(this.$form.querySelectorAll('input, select')).every((input) => input.value !== '');
  };

  isDirty = () => {
    if (!this._initialValues) return false;
    const current = this.getFormValues();
    const keys = Object.keys(this._initialValues);
    return keys.some((key) => this._initialValues[key] !== current[key]);
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.$rutInput.value && !validateRut(this.$rutInput.value)) {
      this._touchedRut = true;
      this.$rutErrorMessage.classList.add('show');
      this.$rutErrorMessage.hidden = false;
      return;
    }

    const data = Object.fromEntries(new FormData(e.target));
    this.$button.disabled = true;
    this.$button.textContent = 'Guardando...';
    this.$clearButton.disabled = true;
    this._state.disabledButton = true;
    this._state.disabledMainButton = true;
    this.onStateChange();

    fetch('/cart/update.js', {
      method: 'POST',
      body: new FormData(e.target),
    })
      .then(() => {
        if (data['attributes[RUTEmpresa]'] && data['attributes[RazonSocial]']) {
          this.$label.innerHTML = `<span class="cart-discount__label"><div><span class="pvt-invoicing-label size-label-factura">Factura: ${data['attributes[RazonSocial]']} - ${data['attributes[RUTEmpresa]']}</span></div></span>`;
        } else {
          this.$label.textContent = '';
        }

        this._initialValues = this.getFormValues();
        this._hasSavedData = this.areAllFilled();
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.$button.disabled = false;
        this.$button.textContent = 'Guardar';
        this.$clearButton.disabled = false;
        this.checkFormState();
      });
  };

  handleClear = () => {
    const attributes = {
      RUTEmpresa: null,
      RazonSocial: null,
      Giro: null,
      DireccionEmpresa: null,
      Region: null,
      Comuna: null,
    };
    this.$rutErrorMessage.classList.remove('show');
    this.$clearButton.disabled = true;
    this.$clearButton.textContent = 'Limpiando...';
    this.$button.disabled = true;
    this._state.disabledButton = true;
    this._state.disabledMainButton = true;
    this.onStateChange();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ attributes }),
    })
      .then(() => {
        this.querySelectorAll('input,select').forEach((el) => (el.value = ''));
        this.$label.textContent = '¿Necesitas factura?';
        this._touchedRut = false;
        this.$rutErrorMessage.hidden = true;
        this._initialValues = this.getFormValues();
        this._hasSavedData = false;
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.$button.disabled = false;
        this.$button.textContent = 'Guardar';
        this.$clearButton.disabled = false;
        this.$clearButton.textContent = 'Limpiar';
        this.checkFormState();
      });
  };
}

if (!customElements.get('pivot-invoice-form')) {
  customElements.define('pivot-invoice-form', PivotInvoiceForm);
}

const byCountry = {
  cl: function ({ rut }) {
    const regex = /[^\dkK]/g;

    rut = rut.toString().replace(regex, '');
    const dv = rut.slice(-1).toUpperCase();
    if (rut && dv) {
      rut = rut.slice(0, -1) + '-' + dv;
    }
    return rut;
  },
};

function formatDNI({ rut, pais, tipo }) {
  return byCountry[pais?.toLowerCase()]?.({ rut, tipo }) || rut;
}

function validateRut(rut) {
  rut = rut.replace(/[^0-9kK]/g, '');
  if (rut.length < 8 || rut.length > 9) {
    return false;
  }
  let cuerpo = rut.slice(0, -1);
  let dv = rut.slice(-1).toUpperCase();

  let suma = cuerpo
    .split('')
    .reverse()
    .reduce((acc, digit, index) => acc + parseInt(digit) * ((index % 6) + 2), 0);

  let resultado = 11 - (suma % 11);
  let digitoVerificador = resultado === 11 ? '0' : resultado === 10 ? 'K' : resultado.toString();
  return dv == digitoVerificador;
}
